/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HmfSelectorComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronDown,
	homefieldIconChevronUp
} from '@dsg-tech/homefield-angular-icons';

import { ReviewDropdownSelectComponent } from './review-dropdown-select.component';
import { InsideViewportModule } from '../directive/inside-viewport/inside-viewport.module';
import { ClickHandlerModule } from '../directive/click-detection-handler/click-detection-handler.module';

@NgModule({
	imports: [
		ClickHandlerModule,
		CommonModule,
		HmfSelectorComponent,
		HomefieldIconLibraryModule,
		InsideViewportModule
	],
	declarations: [ReviewDropdownSelectComponent],
	exports: [ReviewDropdownSelectComponent]
})
export class ReviewDropdownSelectModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronDown,
			homefieldIconChevronUp
		]);
	}
}
